import { createSlice } from "@reduxjs/toolkit";

interface User {
  name: string;
  permissions: string[];
}
interface InitialState {
  user: User | null;
}

const initialState: InitialState = {
  user: null,
};

export const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    set_user: (state, action) => {
      state.user = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { set_user } = userSlice.actions;

export default userSlice.reducer;
